module.exports = __webpack_public_path__ + "img/avatar.92fb073a.png";